export default __webpack_public_path__ + "static/media/invitation_sent.23fb229e.svg";